
export { deleteCurrentURLState } from "/vercel/path0/packages/shared-values/src/actions/replace-current-url-state.ts"